var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent, cloneElement } from 'react';
import { defaultStepsProps } from './defaults';
import toArray from './toArray';
import { DivTag } from '../../Utils/AtomicTag';
import { Step } from './Step';
var Steps = /** @class */ (function (_super) {
    __extends(Steps, _super);
    function Steps(props) {
        var _this = _super.call(this, props) || this;
        _this.onStepClick = function (next) {
            var _a = _this.props, current = _a.current, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange;
            if (current !== next && onBeforeChange()) {
                onChange(next);
            }
        };
        return _this;
    }
    Steps.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, direction = _a.direction, status = _a.status, size = _a.size, current = _a.current, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange, rest = __rest(_a, ["children", "direction", "status", "size", "current", "onChange", "onBeforeChange"]);
        var currentNum = Number(current);
        var isV = direction === 'vertical';
        var boxCls = isV ? ['flex', 'flex-wrap', 'w-px-178'] : ['flex'];
        return (React.createElement(DivTag, __assign({ name: Steps.NAME, atomics: boxCls }, rest), toArray(children).map(function (child, index) {
            var stepNumber = index + 1;
            var childProps = __assign(__assign({ stepNumber: stepNumber, key: stepNumber, stepIndex: index, onStepClick: _this.onStepClick }, child.props), { isV: isV, size: size });
            var len = children && Array.isArray(children) ? children.length : 0;
            childProps.isLast = len === index + 1;
            if (status === 'error' && index === currentNum) {
                childProps.className = "next-error";
            }
            if (!child.props.status) {
                if (index === currentNum) {
                    childProps.status = status;
                }
                else if (index < currentNum) {
                    childProps.status = 'finish';
                }
                else {
                    childProps.status = 'wait';
                }
            }
            childProps.active = index === currentNum;
            return cloneElement(child, childProps);
        })));
    };
    Steps.Step = Step;
    Steps.defaultProps = defaultStepsProps;
    Steps.NAME = 'steps';
    Steps.displayName = 'Steps';
    return Steps;
}(PureComponent));
export { Steps };
